import React from "react";
import styles from "./switcher_menu.module.css"

function SwitcherMenu({
  checkMenu, handleChecked
}) {

  return (
    <div className={`${styles.checkbox}`}>
      <label className={`${styles.label}`}>
        <input
          className={`${styles.button}`}
          type="checkbox"
          checked={checkMenu}
          onChange={handleChecked}
        />
        <div className={`${styles.pen1} ${checkMenu && styles.pen1Moved}`}></div>
        <div className={`${styles.pen2} ${checkMenu && styles.pen2Moved}`}></div>
        <div className={`${styles.pen3} ${checkMenu && styles.pen3Moved}`}></div>
        <div className={`${styles.pen4} ${checkMenu && styles.pen4Moved}`}></div>
      </label>
    </div>
  );
}

export default SwitcherMenu;
